import { AlertCircle, InfoCircle } from "@untitledui/icons";
import type React from "react";

export type AnnouncementSeverity = "info" | "warning" | "error";

export interface SeverityStyle {
  bg: string;
  fg: string;
  border: string;
  accent: string;
  Icon: React.ComponentType<{ className?: string }>;
}

export const SEVERITY_STYLE: Record<AnnouncementSeverity, SeverityStyle> = {
  info: {
    bg: "#EFF6FF",
    fg: "#1E40AF",
    border: "#BFDBFE",
    accent: "#3B82F6",
    Icon: InfoCircle,
  },
  warning: {
    bg: "#FEF3C7",
    fg: "#92400E",
    border: "#FDE68A",
    accent: "#D97706",
    Icon: AlertCircle,
  },
  error: {
    bg: "#FEE2E2",
    fg: "#991B1B",
    border: "#FECACA",
    accent: "#DC2626",
    Icon: AlertCircle,
  },
};
